module.exports = __webpack_public_path__ + "img/f2.4d50386c.png";